import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./lib/auth";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Bibliotheque from "./pages/Bibliotheque";
import Article from "./pages/Article";
import Prematurite from "./pages/Prematurite";
import PremaFiche from "./pages/PremaFiche";
import Journal from "./pages/Journal";
import Epds from "./pages/Epds";
import Meditation from "./pages/Meditation";
import Aide from "./pages/Aide";
import Boutique from "./pages/Boutique";
import Profil from "./pages/Profil";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import MentionsLegales from "./pages/MentionsLegales";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/bibliotheque" element={<Bibliotheque />} />
            <Route path="/article/:id" element={<Article />} />
            <Route path="/prematurite" element={<Prematurite />} />
          <Route path="/prema/:id" element={<PremaFiche />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/epds" element={<Epds />} />
            <Route path="/meditation" element={<Meditation />} />
            <Route path="/aide" element={<Aide />} />
            <Route path="/boutique" element={<Boutique />} />
            <Route path="/profil" element={<Profil />} />
          </Route>
          <Route path="/login" element={<Auth />} />
          <Route path="/register" element={<Auth />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
